import { Button as MuiButton, ButtonProps } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

const Button = ({ variant = 'contained', sx = {}, ...props }: ButtonProps) => {
  const isContained = variant === 'contained';
  const isOutlined = variant === 'outlined';

  const customStyles: SxProps<Theme> = {
    width: 'fit-content',
    padding: '5px 20px',
    borderRadius: '6px',
    fontFamily: 'Montserrat, sans-serif',
    textTransform: 'none',
    backgroundColor: isContained ? 'var(--accent-color)' : 'transparent',
    color: isContained ? 'var(--additional-color)' : 'var(--accent-color)',
    border: isOutlined ? '1px solid var(--accent-color)' : 'none',
    '&:hover': {
      backgroundColor: isContained ? 'var(--accent-hover-color)' : 'rgba(0, 0, 0, 0.04)',
      borderColor: isOutlined ? 'var(--accent-hover-color)' : undefined,
    },
    '&.Mui-disabled': {
      backgroundColor: isContained ? 'var(--secondary-color)' : 'transparent',
      color: 'var(--primary-color)',
      borderColor: isOutlined ? 'var(--secondary-color)' : undefined,
    },
  };

  return (
    <MuiButton
      variant={variant}
      disableElevation
      sx={{ ...customStyles, ...sx }} // <— объединение через spread
      {...props}
    >
      {props.children}
    </MuiButton>
  );
};

export { Button };
